import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import configureStore from "./configureStore";

//Code splitting between admin and user components (MUI only loads with the admin)
const App = React.lazy(() => import("./components/App"));
const AdminApp = React.lazy(() => import("./adminComponents/AdminApp"));


let store = configureStore();

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const path = window.location.pathname;
const isAdmin = path.startsWith("/admin");

const root = createRoot(rootElement);
root.render(
  <BrowserRouter basename={baseUrl}>
    <Provider store={store}>
      <React.Suspense fallback={null}>
        {isAdmin ? <AdminApp /> : <App />}
      </React.Suspense>
    </Provider>
  </BrowserRouter>,
);
